import axios from "axios";
import {baseUrlApiOtodis, xApiKeyOtodis} from "../../config/api/apiConfig";

class OrderPolicyService {
    private axios = axios.create({
        baseURL: baseUrlApiOtodis,
    });
    private axiosFile = axios.create({
        baseURL: baseUrlApiOtodis,
        responseType: 'blob'
    });

    public setToken(token: string) {
        this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    }

    public async getData(params?: any) {
        const queries = {
            ...(params?.vehicleModel && {
                vehicle_model: params.vehicleModel,
            })
        }
        try {
            return await this.axios.get<any>(`/config/order-policy/${params.companyCode}`, {
                headers: {
                    "X-Api-Key": xApiKeyOtodis,
                },
                params: {
                    ...queries,
                }
            });
        } catch (e: any) {
            throw new Error(e.response.data.message);
        }
    }

    public async createUpdateData(inputData?: any) {
        try {
            return await this.axiosFile.post<any>('/config/order-policy',
                inputData, {
                    headers: {
                        "X-Api-Key": xApiKeyOtodis,
                    }
                });
        } catch (e: any) {
            throw new Error(e.response.data.message);
        }
    }


}

export const orderPolicyService = new OrderPolicyService();
